var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,class:['menu-item', { active: index == _vm.activeIndex }],on:{"click":function($event){return _vm.onChange(item, index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }